import * as React from "react";
import { FGSelectInput, FGNumberInput, FGTextInput } from "nsitools-react";
import { ETLCodes } from "../../../../locales";
import { useTl } from "../../../../hooks";
import { useReferential } from "../../../../hooks/useReferential";
import { EHealthValueType } from "../../../../api";

export interface IDysplasiaRequestValueResultProps {
  index: number;
  dysplasiaIndex: number;
  characteristicType?: EHealthValueType;
  characteristicId?: number;
}

export const DysplasiaRequestValueResult: React.FunctionComponent<IDysplasiaRequestValueResultProps> = ({
  index,
  dysplasiaIndex,
  characteristicType,
  characteristicId,
}) => {
  const { t } = useTl();

  const [characValues, cvloading] = useReferential((a) => a.getHealthValues(characteristicId));

  return characteristicType === EHealthValueType.ValueList ? (
    <FGSelectInput
      name={`transientDysplasiaTypes[${index}].transientDysplasias[${dysplasiaIndex}].healthValueId`}
      label={t(ETLCodes.Value)}
      items={characValues}
      loading={cvloading}
      readonly
    />
  ) : characteristicType === EHealthValueType.Numeric ? (
    <FGNumberInput
      name={`transientDysplasiaTypes[${index}].transientDysplasias[${dysplasiaIndex}].numericValue`}
      label={t(ETLCodes.Value)}
      readonly
    />
  ) : (
    <FGTextInput
      name={`transientDysplasiaTypes[${index}].transientDysplasias[${dysplasiaIndex}].alphaValue`}
      label={t(ETLCodes.Value)}
      readonly
    />
  );
};
